import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from '../services/base.service';
import { AppService } from 'src/app/app.service';

import { environment } from 'src/environments/environment';
import { IResponse } from 'src/app/shared/models/app';

import { ApiPrefix } from '../constants/api.constant';
import { Environment } from './environment';
import { AppConstant } from '../constants/app.constant';
import { config } from 'process';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService extends BaseService {
  /*********************Properties*********************/
  private environment: Environment = Environment.getInstance();
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    protected http: HttpClient,
    private appService: AppService) {
    super(http);
  }
  /*********************Constructor*********************/

  /*********************Service Methods*********************/

  getConfig(): Promise<boolean> {

    return new Promise((resolve, reject) => {
      super
        .fetch('/api/env/getService', {})
        .subscribe((response: IResponse) => {
          if (!response.hasError) {
            this.onConfigResponse(response.data);
            this.appService.init();

            return this.appService.initOnLoad().then((load) => {
              if (load) {
                this.appService.load().then(() => {
                  resolve(true);
                });
              } else {
                resolve(true);
              }
            });
          }

          return resolve(false);
        });
    });
  }

  /*********************Service Methods*********************/

  /*********************Private Methods*********************/

  private onConfigResponse(response:any): void {
    this.environment.appConfig.apiKey = response.apikey;
    this.environment.appConfig.apigeeTokenEndpoint = response.apigeeTokenEndpoint;
    this.environment.oktaConfig.clientId = response.oktaClientId;
    this.environment.oktaConfig.oktaTokenEndpoint = response.oktaTokenEndpoint;
    this.environment.appConfig.restrictInternalUser = response.restrictInternalUser;
    this.environment.appConfig.environment = response.environment;
    this.environment.appConfig.apiRequestTimeout = response.apiRequestTimeout;
    this.environment.appConfig.nphsWOBannerTopImg = response.nphsWOBannerTopImg;
    this.environment.appConfig.nphsWOBannerTopUrl = response.nphsWOBannerTopUrl;
    this.environment.appConfig.nphsWOBannerBottomImg = response.nphsWOBannerBottomImg;
    this.environment.appConfig.nphsWOBannerBottomUrl = response.nphsWOBannerBottomUrl;
    this.environment.appConfig.wo340BEmailInquires = response.wo340BEmailInquires;
    this.environment.appConfig.sonexusRedirectPublicKey = response.sonexusRedirectPublicKey;

    this.environment.apiConfig = {
      config:response.config,
      login:response.login,
      order:response.order,
      user:response.userWO,
    };

  }

  private setPropLocalUrls() {

    // //To Run in local, copy API key from environment.local.env file present at root.
    // this.environment.appConfig.apiKey = "TDM6cgXT9OH4q0FaQ7XVldkkGPUSNTbW";//process.env.APIKEY;
    // this.environment.appConfig.apigeeTokenEndpoint = "https://api.stage.cardinalhealth.com/oauth2/v3/token/jwtforoktab2b";
    // this.environment.oktaConfig.clientId = '0oazk1v3ucUZFY6G70h7';
    // this.environment.oktaConfig.oktaTokenEndpoint = 'https://myidb2bstg.cardinalhealth.com/oauth2/v1/token';
    //   this.environment.appConfig.restrictInternalUser = false;
    //   this.environment.appConfig.environment = "dev";
    //   this.environment.appConfig.apiRequestTimeout = "25";
    //   this.environment.appConfig.nphsWOBannerTopImg = 'https://npswo.stg.cardinalhealth.com/assets/images/banner-theranostics.png';
    //   this.environment.appConfig.nphsWOBannerTopUrl = 'https://nps.info.cardinalhealth.com/l/62812/2022-10-06/4q2gvy';
    //   this.environment.appConfig.nphsWOBannerBottomImg = 'https://npswo.stg.cardinalhealth.com/assets/images/banner-lsk-surgeon-perspective.jpg';
    //   this.environment.appConfig.nphsWOBannerBottomUrl = 'https://nps.info.cardinalhealth.com/l/62812/2018-07-27/4drnss';

    //   this.environment.apiConfig = {
    //     config: 'https://api.dev.cardinalhealth.com/nphs/wo-config/v1/config',
    //     login: 'https://npslogin.dev.cardinalhealth.com/',
    //     order: 'https://api.dev.cardinalhealth.com/nphs/wo-order/v1/order',
    //     user: 'https://api.dev.cardinalhealth.com/nphs/wo-user/v1/user',
    //   };
  }

  /*********************Private Methods*********************/
}
